<table>
  <tr>
    <td id='canvas'>
      <section>
        <ko-stage #stage id="stage" class="{{leftOrRight}}" [config]="configStage" (dragenter)="onDragEnter($event)"
          (dragover)="onDragOver($event)" (drop)="onDrop($event)" (dragleave)="onDragLeave($event)">
          <ko-layer #layerPage [config]="configLayerPage"></ko-layer>
          <ko-layer #layerSection [config]="configLayerSection"></ko-layer>
          <ko-layer #layerKoma [config]="configLayerKoma"></ko-layer>
          <ko-layer #layerKomaProxy [config]="configLayerKomaProxy"></ko-layer>
          <ko-layer #layerKomaFrame [config]="configLayerKomaFrame"></ko-layer>
        </ko-stage>
      </section>
    </td>
  </tr>
</table>
